module.exports = __webpack_public_path__ + "fonts/fa-regular-400.366d7e2.woff";